import i18next from 'i18next';
import { z } from 'zod';

export const setupZodErrorMap = () => {
  const customErrorMap: z.ZodErrorMap = (issue, ctx) => {
    let message: string;

    switch (issue.code) {
      case z.ZodIssueCode.invalid_string:
        if (issue.validation === 'url') {
          message = i18next.t('invalid_url', { ns: 'global' });
        } else {
          message = ctx.defaultError;
        }
        break;
      case z.ZodIssueCode.too_small:
        // Превращаем строку с min=1 в наш универсальный ключ 'required'
        if (issue.type === 'string' && issue.minimum === 1) {
          message = i18next.t('required', { ns: 'global' });
        } else if (issue.type === 'number') {
          message = i18next.t('too_small_number', {
            ns: 'global',
            minimum: issue.minimum,
          });
        } else {
          message = ctx.defaultError;
        }
        break;

      case z.ZodIssueCode.too_big:
        if (issue.type === 'number') {
          message = i18next.t('too_big_number', {
            ns: 'global',
            maximum: issue.maximum,
          });
        } else {
          message = ctx.defaultError;
        }
        break;

      case z.ZodIssueCode.invalid_type:
        if (issue.received === 'undefined' || issue.received === 'null') {
          // Используем стандартный ключ 'required'
          message = i18next.t('required', { ns: 'global' });
        } else {
          message = ctx.defaultError;
        }
        break;

      // Для остальных типов ошибок используем стандартное сообщение
      default:
        message = ctx.defaultError;
    }

    return { message };
  };

  // Установка кастомной карты ошибок глобально
  z.setErrorMap(customErrorMap);
};
